import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const Tealium = ({ isOrderConfirmation = false }) => {
  const cart = useSelector((state) => state.cart);
  const isCartLoaded = useSelector((state) => state.cart?.status === 'succeeded');
  const order = useSelector((state) => state.order);
  const isOrderLoaded = useSelector((state) => state.order?.status === 'succeeded');
  const [tealiumReadyFired, setTealiumReadyFired] = useState(false);

  useEffect(() => {
    if (!tealiumReadyFired && isOrderConfirmation && isOrderLoaded) {
      const tealiumDataReadyEvent = new CustomEvent('tealiumDataReady', { detail: { order } });
      document.dispatchEvent(tealiumDataReadyEvent);
      setTealiumReadyFired(true);
    } else if (!tealiumReadyFired && isCartLoaded) {
      const tealiumDataReadyEvent = new CustomEvent('tealiumDataReady', { detail: { cart } });
      document.dispatchEvent(tealiumDataReadyEvent);
      setTealiumReadyFired(true);
    }
  }, [
    cart,
    isCartLoaded,
    order,
    isOrderLoaded,
    isOrderConfirmation,
    tealiumReadyFired,
  ]);

  return <></>;
};

Tealium.propTypes = {
  isOrderConfirmation: PropTypes.bool,
};

export default Tealium;
